import { Paper } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import { t } from "../../../i18n/util";
import { hrStore } from "../../../stores/HrStore";
import { HistoryLine, SectionHeaderSmall } from "../../ui/Primitives";
import { historyToApplicantPicture } from "../../util/helpers";
import { sortBy } from "lodash";
import moment from "moment";

export const ApplicantHistorySite = observer(() => {
    const historyList = hrStore.currentApplicant.history?.slice() || [];

    const sortedHistory = sortBy(historyList, (item) =>
        item.transitionDate ? moment(item.transitionDate).valueOf() : 0
    ).reverse();

    return (
        <Paper style={{ padding: 24 }}>
            <SectionHeaderSmall label={t("screen.applicantDetails.history")} style={{ marginBottom: 20 }} />
            {sortedHistory.map((history, index) => (
                <HistoryLine
                    key={index}
                    history={history}
                    name={`${hrStore.currentApplicant.firstName} ${hrStore.currentApplicant.lastName}`}
                    applicantPicture={historyToApplicantPicture(history, hrStore.currentApplicant)}
                />
            ))}
        </Paper>
    );
});